import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectCurrentSiteId
} from '../../../features/site/site.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigPanelMode } from '../../../enums/config';
import {
  selectConfigRightPanelMode
} from '../../../features/config/config.selectors';
import { map } from 'rxjs/operators';
import {
  setConfigRightPanelMode
} from '../../../features/config/config.actions';

@Component({
    selector: 'right-panel',
    templateUrl: './right-panel.component.html',
    styleUrls: ['./right-panel.component.scss'],
    standalone: false
})
export class RightPanelComponent {

  readonly isSiteSelected$ = this.store.select(selectCurrentSiteId).pipe(map(id =>  id != null));
  siteSelected: boolean = false;
  rightSideMode: ConfigPanelMode = ConfigPanelMode.MODE_EXPANDED;
  sideModeEnum = ConfigPanelMode;

  constructor(private store: Store) {
    this.handleSiteSelected();
    this.handleConfig();
  }

  private handleSiteSelected(): void {
    this.store.select(selectCurrentSiteId)
      .pipe(takeUntilDestroyed())
      .subscribe(id => {
        this.siteSelected = !!id;
      })
  }

  private handleConfig(): void {
    this.store.select(selectConfigRightPanelMode)
      .pipe(takeUntilDestroyed())
      .subscribe((mode: ConfigPanelMode) => {
        this.rightSideMode = mode;
      });
  }

  togglePanel(): void {
    const mode = (this.rightSideMode === ConfigPanelMode.MODE_EXPANDED) ? ConfigPanelMode.MODE_COLLAPSED : ConfigPanelMode.MODE_EXPANDED;
    this.store.dispatch(setConfigRightPanelMode({mode}));
  }
}
